import React from 'react'
import { IMkStepperContext } from '@typescript'
import type { IMkBookingError } from '@book/types'
import type { IWaitlistDraft } from '../../types'

export interface WaitlistContextType extends IMkStepperContext {
  waitlistDraft: IWaitlistDraft | undefined
  isLoading: boolean
  waitlistErrors: IMkBookingError[]
  initWaitlistCreate: () => Promise<void>
  submitWaitlistCreate: () => Promise<void>
  resetWaitlistCreate: () => void
}

export const WaitlistContext = React.createContext<WaitlistContextType | undefined>(undefined)
